// Copyright 2019 Drivetrain Hub LLC
// Vuex store for managing global state of the application.
//
// Vuex is particularly helpful when state is used by or changed by multiple components, particularly when those
// components do not have a direct parent-child relationship.
//
// NOTES
//  1. Vuex store architecture with modules
//    a. https://vuex.vuejs.org/guide/structure.html
//    b. https://vuex.vuejs.org/guide/modules.html
//    c. Example - https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example
//  2. Vuex actions
//    a. All actions should involve an async API call, e.g. via Apollo Client.
//    b. If an async event call is not required, then a Vuex mutation only should suffice.
//    c. Examples
//      i. async/await - https://markus.oberlehner.net/blog/combining-graphql-and-vuex/
//      ii. Promise.then() - https://jasonwatmore.com/post/2018/07/06/vue-vuex-jwt-authentication-tutorial-example
//  3. To refactor the use of a state, search project folder for the following:
//      $store.state
//      state.<name>
//      ...mapState
//  4. How to clear Vuex state (see comments by starfruitsolutions and robsonsobral):
//    https://github.com/vuejs/vuex/issues/1118

import Vue from 'vue'
import Vuex from 'vuex'
import eng from './modules/eng';
import lib from './modules/lib';
import model from './modules/model';
import session from './modules/session';
import ui from './modules/ui';
import {copyDeep} from "../assets/js/utils";
import {EventBus} from "../event_bus";

Vue.use(Vuex);

let initialState = {
  model: { ...model.state },
  ui: { ...ui.state }
};

export const store = new Vuex.Store({
  modules: {
    eng: eng,
    lib: lib,
    model: model,
    session: session,
    ui: ui,
  },
  mutations: {
    async RESET_MODELING (state) {
      // WARNING: Tried clearing Apollo here, but throws error:
      // Error sending the query 'release' Invariant Violation: Store reset while query was in flight

      // reset 3D scene
      EventBus.$emit('reset-modeling');

      // reset Vuex store
      Object.keys(initialState).forEach(key => {
        state[key] = copyDeep(initialState[key])
      });
    },
    RESET_UI (state) {
      state.ui = copyDeep(initialState.ui)
    },
  }
});
